(function ($) {
    class W4D_Cart {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.setupCartUpdateListener();
            this.updateRadioLabelsOnInitialPageLoad();
            this.isClearing = false;
        }

        initSelectors() {
            this.$body = $('body');
            this.woocommerce = $('.woo-wrapper');
            this.cart = $('.cart');
            this.removeCartItem = '.js-remove-cart-item';
            this.cartCollaterals = $('.cart-collaterals');
            this.progressBar = $('.progress-bar');
            this.$addToCartButton = '.w4d_add_to_cart_button.single_add_to_cart_button';
            this.$sendInquiryButton = $('.w4d-send-inquiry');
            this.emptyCart = 'dialog[data-dialog="empty-cart-confirmation"] button[data-confirm]';
            this.$stockStatusElements = {
                instock: $(".shop-sidebar__info .instock"),
                outofstock: $(".shop-sidebar__info .availability.availability--query"),
                onbackorder: $(".shop-sidebar__info .availability.availability--backorder"),
            };
            this.availabilityBtn = $('.availability-notify__dialog-open-btn');

            // Cache core selectors used by variation flow
            this.$variationSelects = $('.variations select');
            this.$ident = $('.shop-sidebar__info span.ident');
            this.$summaryDescription = $('#summary-description .accordion__content');
            this.$variationPrice = $('.single_variation_wrap .woocommerce-variation-price');
            this.$samoPregled_showPrice = this.$variationPrice.attr('data-js-show-price');
        }

        bindEvents() {
            this.$body.on('click', '.w4d_add_to_cart_button', (e) => this.handleAddToCart(e));
            $(document).on('click', this.removeCartItem, (e) => this.handleRemoveCartItem($(e.currentTarget)));
            $(document).on('change', '.variations select', (e) => this.handleVariationChange(e));
            $(document).on('change', '.variations__input[type="radio"]', (e) => this.handleAdvancedVariationChange(e));
            $(document).on('click', this.emptyCart, (e) => this.handleRemoveCartAll($(e.currentTarget)));

            const selectCount = $('.variations select').length;
            const selectedOptionsCount = $('.variations select option:selected[value!=""]').length;
            if (selectCount === selectedOptionsCount) {
                this.handleVariationChange();
            }
        }

        updateRadioLabelsOnInitialPageLoad() {
            const $radios = $('.variations__input[type="radio"]:checked');
            $radios.each(function() {
                const $radio = $(this);
                const $radioLabel = $(`label[for="${ $radio.attr('id') }"]`);
                const value = $radioLabel.attr('title');
                if (!value) return;

                const attrName = $radio.attr('name').replace('attribute_', '');
                const $mainLabel = $(`.variations label[for="${ attrName }"]`);
                if (!$mainLabel.length) return;

                const original = $mainLabel.attr('data-original-text') || '';
                $mainLabel.html(
                    `${ original }<span>: </span>` +
                    `<span class="fw-600 leading-none">${ value }</span>` +
                    `<i class="variations__remove icon-x-rounded"></i>`
                );
            });
        }

        setupCartUpdateListener() {
            this.$body.on('updated_cart_totals wc_cart_emptied', (e) => {
                const itemCount = e.type === 'wc_cart_emptied' ? 0 : $('.cart_item').length;
                W4D_FrontendHelper.updateCartIcon(itemCount);
            });
        }

        handleRemoveCartAll($item) {
            const $cartContainer = $('.woocommerce-cart-form').parent().parent().parent();

            $.ajax({
                type: 'POST',
                url: wc_add_to_cart_params.ajax_url,
                data: {
                    action: 'w4d_empty_cart',
                    nonce: w4d_frontend_ajax.nonce
                },
                beforeSend: () => {
                    this.cart.addClass('cart--loading');
                    this.cartCollaterals.addClass('cart-collaterals--loading');
                },
                success: (response) => {
                    if (response.success) {
                        W4D_FrontendHelper.showNotice('success', 'Košarica ispraznjena!');
                        W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
                        this.cartCollaterals.html(response.data.cart_summary);
                        if (response.data.cart_empty_html) {
                            this.handleCartEmptyState(response.data.cart_empty_html, $cartContainer);
                        }
                    }
                },
                complete: () => {
                    setTimeout(() => {
                        this.cart.removeClass('cart--loading');
                        this.cartCollaterals.removeClass('cart-collaterals--loading');
                    }, 150);
                },
                error: (xhr, status, error) => {
                    console.error("Greška u pozivu:", error);
                }
            });
        }

        handleRemoveCartItem($item) {
            const productId = $item.data('product-id');
            const variationId = $item.data('variation-id');
            const cartItemKey = $item.data('cart-item-key');
            const $cartRow = $item.closest('.cart__item');
            const productName = $cartRow.find('.product-name a').text();
            const $cartContainer = $('.woocommerce-cart-form').parent().parent().parent();

            const ajaxData = {
                action: 'w4d_add_to_cart',
                cart_item_key: cartItemKey,
                product_id: productId,
                variation_id: variationId,
                quantity: 0,
                update_cart: true,
                return_cart_data: true,
                nonce: w4d_frontend_ajax.nonce
            };

            $cartRow.addClass('removing');

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    this.cart.addClass('cart--loading');
                    this.cartCollaterals.addClass('cart-collaterals--loading');
                    $cartRow.addClass('cart__item--removing');
                },
                success: (response) => {
                    if (response.success) {
                        $cartRow.slideUp(300, function () {
                            $(this).remove();
                        });
                        W4D_FrontendHelper.showNotice('success', `${productName} uklonjen`);
                        W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
                        this.cartCollaterals.html(response.data.cart_summary);

                        if (response.data.cart_empty_html) {
                            this.handleCartEmptyState(response.data.cart_empty_html, $cartContainer);
                        }

                        W4D_ProgressBar.updateProgressAfterCartChange(response.data.cart_total);
                    }
                },
                complete: () => {
                    setTimeout(() => {
                        this.cart.removeClass('cart--loading');
                        this.cartCollaterals.removeClass('cart-collaterals--loading');
                    }, 150);
                },
                error: (xhr, status, error) => { }
            });
        }

        handleCartEmptyState(html, element) {
            element.empty().html(html);
            $('.woo-wrapper__sidebar').remove();
        }

        handleUpdateCartOnCartPage(input) {
            const $cartRow = input.closest('.cart__item');
            const inputValue = parseFloat(input.attr('value'));
            const $step = parseFloat(input.attr('step'));
            const $step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($step);
            const remainder = inputValue % $step;
            let roundedValue;

            if (remainder > 0) {
                roundedValue = W4D_ProductQuantityHelper.roundToDecimalPlaces(Math.ceil(inputValue / $step) * $step, $step_decimal_places);
            } else {
                roundedValue = inputValue;
            }

            const displayValue = String(roundedValue).replace('.', ',');

            input.val(displayValue)
                .attr('value', roundedValue)
                .attr('data-quantity', roundedValue)
                .data('quantity', roundedValue)
                .trigger('change');

            const ajaxData = {
                action: 'w4d_add_to_cart',
                update_cart: true,
                return_cart_data: true,
                product_id: input.data('product-id'),
                variation_id: input.data('variation-id'),
                quantity: roundedValue,
                nonce: w4d_frontend_ajax.nonce
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    $cartRow.addClass('cart__item--removing');
                },
                success: (response) => {
                    if (response.success) {
                        W4D_FrontendHelper.showNotice('success', 'Košarica je uspješno ažurirana');
                        W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
                        const cartItemRow = input.closest('tr.woocommerce-cart-form__cart-item');
                        const totalElement = cartItemRow.find('.product-subtotal');
                        if (totalElement.length) {
                            totalElement.html(response.data.item_total);
                        }
                        if (response.data.cart_summary) {
                            $('.cart-collaterals').html(response.data.cart_summary);
                        }
                        W4D_ProgressBar.updateProgressAfterCartChange(response.data.cart_total);
                    } else {
                        W4D_FrontendHelper.showNotice('error', 'Greška: ' + response.data.message);
                        console.error(response.data.message);
                    }
                },
                complete: () => {
                    setTimeout(() => {
                        this.cart.removeClass('cart--loading');
                        this.cartCollaterals.removeClass('cart-collaterals--loading');
                    }, 150);
                },
                error: () => this.handleAddToCartError()
            });
        }

        handleUpdateCart($element) {
            const location = $element.data('location');
            let $new_qty;
            const product_id = $element.data('product-id');

            if (location === 'product-flyout') {
                $new_qty = parseFloat($element.data('quantity'));
            }

            if (location === 'table-view') {
                $new_qty = parseFloat($element.attr('value'));
            }

            const data = {
                action: 'w4d_add_to_cart',
                update_cart: true,
                return_cart_data: false,
                product_id: product_id,
                quantity: $new_qty,
                nonce: w4d_frontend_ajax.nonce
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: data,
                beforeSend: () => {
                    if ($element.hasClass('w4d_update_cart_button')) {
                        $element.prop('disabled', true);
                    }
                    this.setButtonLoading($element, true);
                },
                success: (response) => {
                    if (response.success) {
                        if ($element.hasClass('w4d_update_cart_button')) {
                            this.handleProductFlyoutUpdateCartSuccess(response, $element, $new_qty);
                        } else {
                            this.handleUpdateCartSuccess(response, $element);
                        }
                        W4D_FrontendHelper.showNotice('success', 'Košarica uspješno ažurirana');
                    } else {
                        const cartIcon = $element.parent().find('.product-quantity__cart');
                        cartIcon.addClass('product-quantity__cart--error');
                    }
                    const input = $element.parent().find('.product-quantity__number:first');
                    input.attr('data-quantity', $new_qty).data('quantity', $new_qty).trigger('change');
                },
                complete: () => {
                    $element.toggleClass('loading');
                },
                error: () => this.handleAddToCartError()
            });
        }

        handleProductFlyoutUpdateCartSuccess(response, button, quantity) {
            W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
            $('.product-flyout__content .product-quantity__number')
                .data('quantity', quantity)
                .attr('data-quantity', quantity);

            const productId = button.data('product-id');
            $(`.product-table__row[data-product-id="${productId}"] .product-quantity__number`)
                .data('quantity', quantity)
                .attr('data-quantity', quantity)
                .val(quantity)
                .attr('value', quantity);

            $(`.product-table__row[data-product-id="${productId}"] .product-table__data--item-total`)
                .html(response.data.item_total);

            button.prop('disabled', true);
        }

        handleUpdateCartSuccess(response, input) {
            const totalElement = input.closest('.product-table__row').find('.product-table__data--item-total');
            totalElement.removeClass('animate-total');

            W4D_FrontendHelper.updateCartIcon(response.data.cart_count);

            const $parent = input.parent();
            $parent.addClass('product-quantity--added-to-cart');

            totalElement.html(response.data.item_total).addClass('animate-total');

            setTimeout(() => totalElement.removeClass('animate-total'), 500);
            setTimeout(() => {
                $parent.removeClass('product-quantity--added-to-cart')
                    .removeClass('product-quantity--changed');
            }, 2300);
        }

        handleAddToCart(e) {
            e.preventDefault();
            const $button = $(e.currentTarget);
            let quantity;
            let oblpopak = $button.parent().find('.product-quantity__number').attr('min') ?? 1;

            if ($button.hasClass('single_add_to_cart_button')) {
                quantity = parseFloat($button.parent().find('.product-quantity__number').attr('value').replace(',', '.'));
            } else {
                quantity = $button.data('quantity');
            }
            if (!(quantity % oblpopak === 0)) {
                quantity = Math.ceil(quantity / oblpopak) * oblpopak;
            }

            const data = {
                action: 'w4d_add_to_cart',
                product_id: $button.data('product-id'),
                quantity: quantity,
                variation_id: $button.data('variation-id') || 0,
                nonce: w4d_frontend_ajax.nonce
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: data,
                beforeSend: () => this.setButtonLoading($button, true),
                success: (response) => this.handleAddToCartSuccess(response, $button),
                complete: () => this.setButtonLoading($button, false),
                error: () => this.handleAddToCartError()
            });
        }

        setupLoadingClickPrevention() {
            $(this.$addToCartButton).on('click', (e) => {
                if ($(e.currentTarget).hasClass('loading')) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            });
        }

        setButtonLoading($button, isLoading) {
            $button.toggleClass('loading', isLoading);
            $button.prop('disabled', isLoading);
        }

        handleAddToCartSuccess(response, button) {
            if (response.success) {
                W4D_FrontendHelper.showNotice('success', 'Artikl je dodan u košaricu.');
                W4D_FrontendHelper.updateCartIcon(response.data.cart_count);

                const productId = button.data('product_id');
                const totalElement = $(`.product-table__row[data-product-id="${productId}"] .product-table__data--item-total`);
                if (totalElement.length) {
                    totalElement.html(response.data.item_total);
                }
            } else {
                W4D_FrontendHelper.showNotice('error', 'Greška: ' + response.data.message);
                console.error(response.data.message);
            }
        }

        handleAddToCartError() {
            W4D_FrontendHelper.showNotice('error', 'Došlo je do greške prilikom dodavanja artikla u košaricu.');
        }

        // >----------------------------------------- VARIABLE PRODUCT METHODS -----------------------------------------<

        handleVariationChange() {
            if($('.variations_container').length === 0) return;
            this.setupLoadingClickPrevention();

            const selectedAttributes = this.getSelectedAttributes();
            const selectedFromRadios = this.getSelectedAttributesFromRadios();
            const selectedCombined = { ...selectedAttributes, ...selectedFromRadios };

            this.updateSelectOptions();
            this.updateRadioOptions(selectedCombined);

            const matchingVariation = this.findMatchingVariation(selectedCombined);
            if (matchingVariation) {
                this.updateVariationData(matchingVariation);
            } else {
                this.resetVariationData();
            }
        }

        // Called when a Color radio changes
        handleAdvancedVariationChange(e) {
            const $radio = $(e.currentTarget);
            const attrName = $radio.attr('name');
            const value = $radio.val();

            const $label = $radio.next('label');
            const labelText = ($label.attr('title') || '').trim();
            this.handleAdvancedAttributeNameChange(attrName, labelText);

            if (!attrName || value == null) return;

            // 1) Radios (Color)
            const selectedFromRadios = this.getSelectedAttributesFromRadios();

            // 2) Selects (Number, Type)
            const selectedFromSelects = this.getSelectedAttributes();

            // 3) Combine them
            const selectedCombined = { ...selectedFromSelects, ...selectedFromRadios };

            // 4) Filter Number/Type selects based on the Color selection
            this.updateSelectOptionsWithSelection(selectedCombined);

            // 5) Disable unavailable radios based on current choices
            this.updateRadioOptions(selectedCombined);

            // 6) Try to find a full match; it will only match when all attributes are selected
            const matchingVariation = this.findMatchingVariation(selectedCombined);
            if (matchingVariation) {
                this.updateVariationData(matchingVariation);
            } else {
                this.resetVariationData();
            }
        }

        handleAdvancedAttributeNameChange(attrName, value) {
            if (this.isClearing) {
                return;
            }

            // Ensure we have a store for original label texts
            if (!this._originalLabelText) {
                this._originalLabelText = {};
            }

            // 1) Strip the "attribute_" prefix
            const attrNamePretty = String(attrName).replace(/^attribute_/, '');

            // 2) Find the corresponding label by its "for" attribute
            // Your markup uses: <label for="...">...</label>
            const $label = $(`.variations label[for="${attrNamePretty}"]`).first();
            if (!$label.length) {
                return;
            }

            const original = $label.attr('data-original-text') || '';

            if (value && value.length) {
                $label.html(
                    `${ original }<span>: </span>` +
                    `<span class="fw-600 leading-none">${ value }</span>` +
                    `<i class="variations__remove icon-x-rounded"></i>`
                );
            } else {
                $label.html(original);
            }
        }

        // NEW: Disable/enable radios according to what's possible with current selection
        updateRadioOptions(selectedCombined) {
            // Collect radio groups by name
            const groupNames = new Set();
            $('.variations__input[type="radio"]').each(function () {
                const name = $(this).attr('name');
                if (name) groupNames.add(name);
            });

            groupNames.forEach((attributeName) => {
                const $radios = $(`.variations__input[type="radio"][name="${attributeName}"]`);

                // Build a selection that excludes this group's own attribute,
                // so we're only constrained by OTHER attributes.
                const baseSelected = { ...selectedCombined };
                const originalValue = baseSelected[attributeName];
                if (originalValue) {
                    delete baseSelected[attributeName];
                }

                // If there are no other selections, DO NOT constrain this group at all.
                const hasOtherSelections = Object.keys(baseSelected).length > 0;
                if (!hasOtherSelections) {
                    $radios.each(function () {
                        const $radio = $(this);
                        $radio.prop('disabled', false);
                        $radio.next('.variations__label').removeClass('is-disabled');
                    });
                    return;
                }

                const possibleValues = this.getPossibleValuesForAttribute(attributeName, baseSelected);

                $radios.each(function () {
                    const $radio = $(this);
                    const val = $radio.val();
                    const isAllowed = val && possibleValues.has(val);

                    $radio.prop('disabled', !isAllowed);
                    $radio.next('.variations__label').toggleClass('is-disabled', !isAllowed);
                });
            });
        }

        // Build selection from radios (Color)
        getSelectedAttributesFromRadios() {
            const attributes = {};
            $('.variations__input[type="radio"]:checked').each(function () {
                const $radio = $(this);
                const attrName = $radio.attr('name');
                const value = $radio.val();
                if (attrName && value) {
                    attributes[attrName] = value;
                }
            });
            return attributes;
        }

        // Build selection from selects (Number, Type)
        getSelectedAttributes() {
            const attributes = {};
            const $selects = (this.$variationSelects && this.$variationSelects.length)
                ? this.$variationSelects
                : $('.variations select');

            $selects.each(function () {
                const attributeName = $(this).data('attribute_name');
                const attributeValue = $(this).val();
                if (attributeValue && attributeValue.length > 0) {
                    attributes[attributeName] = attributeValue;
                }
            });
            return attributes;
        }

        // Return the first variation that exactly matches all selected attributes
        findMatchingVariation(attributes) {
            const productVariations = $('.variations_container').data('product_variations') || [];
            return productVariations.find(variation =>
                Object.entries(variation.attributes).every(([attr_name, attr_value]) =>
                    attributes[attr_name] === attr_value
                )
            );
        }

        // Return all variations compatible with the current (possibly partial) selection
        findMatchingVariations(selectedAttributes) {
            const productVariations = $('.variations_container').data('product_variations') || [];
            return productVariations.filter((variation) => {
                for (const attr in selectedAttributes) {
                    if (selectedAttributes[attr] && selectedAttributes[attr] !== variation.attributes[attr]) {
                        return false;
                    }
                }
                return true;
            });
        }

        // For a target attribute, return the set of values still possible given current (partial) selection
        getPossibleValuesForAttribute(attributeName, selectedAttributes) {
            const matchedVariations = this.findMatchingVariations(selectedAttributes);
            const possibleValues = new Set();
            matchedVariations.forEach((variation) => {
                if (variation.attributes[attributeName]) {
                    possibleValues.add(variation.attributes[attributeName]);
                }
            });
            return possibleValues;
        }

        // Filter select options in-place using a provided combined selection (radios + selects)
        updateSelectOptionsWithSelection(selectedCombined) {
            const $selects = (this.$variationSelects && this.$variationSelects.length)
                ? this.$variationSelects
                : $('.variations select');

            $selects.each((_, select) => {
                const $select = $(select);
                const attributeName = $select.data('attribute_name');

                // Temporarily remove this attribute to compute possibilities for it
                const baseSelected = { ...selectedCombined };
                const originalValue = baseSelected[attributeName] || '';
                if (originalValue) {
                    delete baseSelected[attributeName];
                }

                const possibleValues = this.getPossibleValuesForAttribute(attributeName, baseSelected);

                // Enable/disable options
                $select.find('option').each(function () {
                    const $opt = $(this);
                    const optionValue = $opt.attr('value');

                    if (optionValue === '') {
                        $opt.prop('disabled', false);
                        return;
                    }

                    const allowed = possibleValues.has(optionValue);
                    $opt.prop('disabled', !allowed).show(); // switch to .hide() if you prefer hiding
                });

                // If current value is no longer valid, clear it
                const currentValue = $select.val();
                if (currentValue && !possibleValues.has(currentValue)) {
                    $select.val('');
                }
            });
        }

        // Legacy: filter selects based only on the select state
        updateSelectOptions() {
            const selectedAttributes = this.getSelectedAttributes();
            const $selects = (this.$variationSelects && this.$variationSelects.length)
                ? this.$variationSelects
                : $('.variations select');

            $selects.each((index, select) => {
                const $select = $(select);
                const attributeName = $select.data('attribute_name');

                // Temporarily remove this attribute
                const baseSelected = { ...selectedAttributes };
                const originalValue = baseSelected[attributeName] || "";
                if (originalValue) {
                    delete baseSelected[attributeName];
                }

                const possibleValues = this.getPossibleValuesForAttribute(attributeName, baseSelected);

                // Re-add original back (not used below, kept for parity with your original structure)
                if (originalValue) {
                    baseSelected[attributeName] = originalValue;
                }

                // Enable/disable options based on possible values
                $select.find('option').each(function () {
                    const optionValue = $(this).attr('value');

                    if (optionValue === "") {
                        $(this).prop('disabled', false);
                        return;
                    }

                    if (possibleValues.has(optionValue)) {
                        $(this).prop('disabled', false).show();
                    } else {
                        $(this).prop('disabled', true).show();
                    }
                });

                // Clear invalid current value
                const currentValue = $select.val();
                if (currentValue && !possibleValues.has(currentValue)) {
                    $select.val("");
                }
            });
        }

        updateVariationData(variation) {
            $(this.$addToCartButton).prop('disabled', false)
                .data('variation-id', variation.variation_id);

            this.$ident.text(variation.ident);
            this.updateStockStatus(variation);
            this.updateDescription(variation);
            this.updatePrice(variation);
            this.updateImage(variation);
            this.updateAttributes(variation);

            const queryString = new URLSearchParams(variation.attributes).toString();
            const newUrl = window.location.pathname + '?' + queryString;
            history.replaceState(null, '', newUrl);
        }

        resetVariationData() {
            history.replaceState(null, '', window.location.pathname);
            $(this.$addToCartButton).prop('disabled', true)
                .removeData('variation-id')
                .attr("aria-hidden", false);
            this.$sendInquiryButton.attr("aria-hidden", true);
            this.availabilityBtn.addClass('hidden');
            this.$ident.text('-');
            this.$variationPrice.empty();
            $('[data-attr-value]').each(function () {
                $(this).html($(this).attr('data-attr-value'));
            });
            Object.values(this.$stockStatusElements).forEach($el =>
                ($el.attr('default') === undefined) ? $el.hide() : $el.show()
            );
        }

        updateStockStatus(variation) {
            Object.values(this.$stockStatusElements).forEach($el => $el.hide());
            const toShow = this.$stockStatusElements[variation.stock_status];
            if (toShow) {
                toShow.show();
            }
        }

        updateDescription(variation) {
            if (variation.variation_description?.trim()) {
                this.$summaryDescription.empty().append(variation.variation_description);
            } else {
                this.$summaryDescription.html(this.$summaryDescription.attr('data-attr-value'));
            }
        }

        updatePrice(variation) {
            this.$variationPrice.empty();

            if (!this.$samoPregled_showPrice) {
                const $stanja = JSON.parse(variation.stanje_skl || '[]');
                if (Array.isArray($stanja)) {
                    $stanja.forEach(stanje => {
                        if (stanje.raspolozivo > 0) {
                            this.$variationPrice.append(
                                '<div class="availability">' +
                                    stanje.naziv + ' (' + stanje.raspolozivo + ')' +
                                '</div>'
                            );
                        } else {
                            this.$variationPrice.append(
                                '<div class="availability availability--backorder">' +
                                    stanje.naziv +
                                '</div>'
                            );
                        }
                    });
                }
            }

            if (variation.hide_price) {
                this.$sendInquiryButton.attr("aria-hidden", false);
                $(this.$addToCartButton).attr("aria-hidden", true);
                this.availabilityBtn.addClass('hidden');

                this.$variationPrice.append(
                    '<div class="variation__price">' +
                        '<div class="variation__price-regular">CIJENA NA UPIT</div>' +
                    '</div>'
                );

                return;
            }

            const regularPrice = parseFloat(variation.display_regular_price);
            const regularPriceText = regularPrice.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            const salePrice = parseFloat(variation.display_price);
            const salePriceText = salePrice.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            const hasValidSale = variation.display_regular_price
                && variation.display_price
                && variation.display_regular_price > variation.display_price;
            const display_jm1_variable = this.$variationPrice.closest('.single_variation_wrap').hasClass('display_jm1');


            if (hasValidSale) {
                const discountPercentage = variation.discount_percentage ?? Math.round(((regularPrice - salePrice) / regularPrice) * 100);

                let discountClass = 'variation__price-sale';
                if (discountPercentage >= 50) {
                    discountClass += ' discount--high';
                } else if (discountPercentage < 25) {
                    discountClass += ' discount--low';
                } else {
                    discountClass += ' discount--medium';
                }

                this.$variationPrice.append(
                    '<div class="variation__price">' +
                    '<div class="' + discountClass + '" data-discount="' + discountPercentage + '">' +
                    salePriceText + ' <span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                   (display_jm1_variable ? '<span class="product_jm1_display"> /' + variation.pakovanje + '</span>' : '') +
                   '</div>' +
                   '<div class="variation__price-regular variation__price-regular--crossed">' +
                   regularPriceText + ' <span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                   '</div>' +
                   '</div>'
               );


                if (variation.lowest_price_30_days && parseFloat(variation.lowest_price_30_days) > 0) {
                    const lowestPrice = parseFloat(variation.lowest_price_30_days).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    this.$variationPrice.append(
                        `<div class="variation__price-lowest-in-30-days">Najniža cijena u posljednjih 30 dana: ${lowestPrice}&nbsp;<span class="woocommerce-Price-currencySymbol">&euro;</span></div>`
                    );
                }
            } else {
                this.$variationPrice.append(
                    '<div class="variation__price">' +
                        '<div class="variation__price-regular">' +
                            regularPriceText + '<span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                    (display_jm1_variable ? '<span class="product_jm1_display"> /' + variation.pakovanje + '</span>' : '') +
                    '</div>' +
                    '</div>'
                );
            }

            if (variation.stock_status === 'outofstock') {
                this.$sendInquiryButton.attr("aria-hidden", false);
                this.availabilityBtn.removeClass('hidden').attr('data-variation-id', variation.variation_id);
                $(this.$addToCartButton).attr("aria-hidden", true);
                return;
            }

            this.$sendInquiryButton.attr("aria-hidden", true);
            this.availabilityBtn.addClass('hidden');
            $(this.$addToCartButton).attr("aria-hidden", false);

            const variationId = variation.variation_id;
            const oblpopak = variation.oblpopak;
            const pakovanje = variation.pakovanje;
            const faktoroblika = parseFloat(variation.faktoroblika);
            const oblik = variation.oblik;

            if (faktoroblika != 1) {
                const oblikPrice = (salePrice / faktoroblika).toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                this.$variationPrice.append(
                    '<div class="variation__price-lowest-in-30-days">' +
                        oblik + ' = ' + oblikPrice + '<span class="woocommerce-Price-currencySymbol">&euro;</span>' +
                    '</div>'
                );
            }

            let decimalPlaces = W4D_ProductQuantityHelper.getDecimalPlaces(oblpopak);
            let value = W4D_ProductQuantityHelper.roundToDecimalPlaces(oblpopak, decimalPlaces);
            let displayValue = value.toString().replace('.', ',');

            let decimalPlaces2 = W4D_ProductQuantityHelper.getDecimalPlaces(faktoroblika);
            let value2 = W4D_ProductQuantityHelper.roundToDecimalPlaces((oblpopak * faktoroblika), decimalPlaces2);
            let displayValue2 = value2.toString().replace('.', ',');
            if(this.$samoPregled_showPrice)return;
            if (faktoroblika === 1) {
                this.$variationPrice.append(
                    '<div class="product-quantity" data-step="' + oblpopak + '">' +
                        '<i class="product-quantity__stepper product-quantity__stepper--wide icon-minus"></i>' +
                        '<input ' +
                            'type="text" ' +
                            'inputmode="decimal" ' +
                            'name="quantity" ' +
                            'value="' + oblpopak + '" ' +
                            'min="1" ' +
                            'max="9999.99" ' +
                            'step="'+ oblpopak +'" ' +
                            'class="product-quantity__number js-jm2" ' +
                            'data-quantity="' + oblpopak + '" ' +
                            'data-faktor="' + faktoroblika + '" ' +
                            'data-location="variable-product" ' +
                        '>' +
                        '<i class="product-quantity__stepper product-quantity__stepper--wide icon-plus"></i>' +
                        '<span class="product-quantity__unit">' + oblik + '</span>' +
                    '</div>'
                );
            } else {
                this.$variationPrice.append(
                    '<div class="product-quantity__dual" data-variation-id="' + variationId + '">' +
                        '<div class="product-quantity" data-step="' + oblpopak + '">' +
                            '<i class="product-quantity__stepper icon-minus"></i>' +
                            '<input ' +
                                'type="text" ' +
                                'inputmode="decimal" ' +
                                'name="quantity" ' +
                                'value="' + displayValue + '" ' +
                                'min="' + oblpopak + '" ' +
                                'max="9999.99" ' +
                                'step="' + oblpopak +'" ' +
                                'class="product-quantity__number js-jm1" ' +
                                'data-quantity="' + oblpopak + '" ' +
                                'data-faktor="' + faktoroblika + '" ' +
                                'data-location="variable-product" ' +
                            '>' +
                                '<i class="product-quantity__stepper icon-plus"></i>' +
                                '<span class="product-quantity__unit">' + pakovanje + '</span>' +
                        '</div>' +
                        '<span class="text-bold">=</span>' +
                        '<div class="product-quantity" data-step="1">' +
                            '<i class="product-quantity__stepper icon-minus"></i>' +
                            '<input ' +
                                'type="text" ' +
                                'inputmode="decimal" ' +
                                'value="' + displayValue2 + '" ' +
                                'min="1" ' +
                                'max="9999.99" ' +
                                'step="'+ faktoroblika +'" ' +
                                'class="product-quantity__number js-jm2" ' +
                                'data-quantity="' + faktoroblika + '" ' +
                                'data-faktor="' + faktoroblika + '" ' +
                                'data-location="variable-product" ' +
                            '>' +
                                '<i class="product-quantity__stepper icon-plus"></i>' +
                                '<span class="product-quantity__unit">' + oblik + '</span>' +
                        '</div>' +
                    '</div>'
                );
            }
        }

        updateImage(variation) {
            if (!variation?.image_id || variation.image_id <= 0) return;

            const $mainGalleryLinks = $('.js-product-gallery > a');

            const tryActivateThumbnail = (retries = 5) => {
                const $thumb = $(`.product-gallery__thumbnail[data-id="${variation.image_id}"]`);
                const $thumbContainer = $('.product-gallery__thumbnails');

                if ($thumb.length) {
                    $('.product-gallery__thumbnail').removeClass('active');
                    $thumb.addClass('active');

                    if ($thumbContainer.length) {
                        const scrollTop = $thumbContainer.scrollTop();
                        const targetTop = $thumb.position().top + scrollTop - 40;
                        $thumbContainer.animate({ scrollTop: targetTop }, 300);
                    }
                } else if (retries > 0) {
                    setTimeout(() => tryActivateThumbnail(retries - 1), 100);
                }
            };

            tryActivateThumbnail();

            const targetSrc = variation.image?.src?.split('?')[0] ?? '';
            let matchedIndex = -1;

            $mainGalleryLinks.each(function (index) {
                const imgSrc = $(this).find('img').attr('src')?.split('?')[0];
                if (imgSrc === targetSrc) {
                    matchedIndex = index;
                    return false;
                }
            });

            if (matchedIndex !== -1) {
                $mainGalleryLinks.removeClass('active');
                $mainGalleryLinks.eq(matchedIndex).addClass('active');

                const newMainSrc = $mainGalleryLinks.eq(matchedIndex).find('img').attr('src');
                $('.product-gallery__main img').attr('src', newMainSrc);
            }
        }

        updateAttributes(variation) {
            Object.entries(variation.attributes).forEach(([attr_name, attr_value]) => {
                const $row = $(`tr.${attr_name}`);
                const optionSlugs = $row.attr('data-slugs');
                if (optionSlugs) {
                    const options = JSON.parse(optionSlugs);
                    if (options[attr_value]?.trim()) {
                        $row.find('td:nth-child(2) p').text(options[attr_value]);
                    }
                }
            });
        }
    }

    $(document).ready(() => {
        window.W4D_Cart = new W4D_Cart();
    });
})(jQuery);